import { render } from "./TheJob.vue?vue&type=template&id=5e85bc23&scoped=true"
import script from "./TheJob.vue?vue&type=script&lang=js"
export * from "./TheJob.vue?vue&type=script&lang=js"

import "./TheJob.vue?vue&type=style&index=0&id=5e85bc23&scoped=true&lang=css"

import exportComponent from "/home/cyrill/Projects/kmapper/repos/cyrill.codeberg.page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e85bc23"]])

export default __exports__